<template>
    <div class="bottom">
        <footer class="footBg">
            <div class="footTop">
                <div class="wrap">
                    <div class="ftLeft f18">
                        <div class="ftLogo"><router-link :to="{path:'/'}"><img src="../assets/logo-white.png"></router-link></div>
                        <div class="ftTel">全国服务热线 ：<span>{{ basic.service_hotline }}</span></div>
                        <div class="ftCon">
                            <p>
                                <span>联系电话：{{basic.phone}}</span>
                                <span>联系邮箱：{{basic.email}}</span>
                            </p>
                            <p>
                                <span>公司地址：{{basic.address_1}}</span>
                                <span>公司总部：{{ basic.address_2 }}</span>
                            </p>
                        </div>
                    </div>
                    <div class="ftRight f16">
                        <ul class="wechat flex">
                            <li>
                                <img :src="img.image006">
                                <p>扫一扫关注搬家</p>
                            </li>
                            <li>
                                <img :src="img.image007">
                                <p>扫一扫关注物流</p>
                            </li>
                        </ul>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>
            <div class="footBot">
                <div class="wrap">
                    <div class="copyRight">
                        <p>北京春溢通物流有限公司   |   版权所有Copyright © 2019 - 2024   |   © <a href="https://beian.miit.gov.cn/state/outPortal/loginPortal.action#/Integrated/index" target="_blank">{{basic.beian}}</a>   |   法律声明  网站地图  <a style="border-left: 1px solid #fff;padding-left: 10px;margin-left: 10px;" href="https://www.etycx.com/" target="_blank">技术支持：时代创信</a></p>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
    import common from '@/api/common'
    export default {
        name: 'Footer',
        data(){
            return{
                basic:'',
                img:''
            }
        },
        mounted () {
            this.baseInfo()
        },
        methods: {
            baseInfo() {
                common.base().then((res) => {
                    if (res.code === 1) {
                        this.basic = res.data.basic
                        this.img = res.data.image
                        localStorage.setItem('banner', JSON.stringify(res.data.image));
                        // let data = JSON.parse(localStorage.getItem('banner'));
                        // console.log(this.basic)
                    } else {
                        this.$toast(res.msg)
                    }
                })
            }
        }
    }    
</script>
<style lang="scss" scoped>
$mainColor:#C39D6C;
.footBg{
    color: rgba($color: #FFFFFF, $alpha: 0.6);
    line-height: 30px;
    background-color: #7A5930;
    background-size: cover;
}
.footTop{
    padding: 40px 0;
}
.ftLeft{
    float: left;
    width: calc(100% - 300px);
    max-width: 780px;
}
.ftLogo{
    img{
        max-height: 56px;
    }
}
.ftTel{
    margin: .3rem 0 .15rem;
    span{
        color: #FFFFFF;
        font-size: 133%;
    }
}
.ftCon{
    line-height: 2;
    p{
        display: flex;
        flex-wrap: wrap;
        margin: 0 -.1rem;
        span{
            display: block;
            min-width: 48%;
            padding: 0 .1rem;
        }
    }
}
.ftRight{
    float: right;
    max-width: 4rem;
    width: 280px;
    text-align: center;
    .wechat{
        margin: 0 -.1rem;
        li{
            flex: 1;
            padding: 0 .1rem;
        }
    }
    img{
        display: block;
        max-width: 100%;
        margin: 0 auto;
    }
}
.footBot{
    line-height: 24px;
    padding: .18rem 0;
    text-align: center;
    a{
        color: rgba($color: #FFFFFF, $alpha: 0.6);
        margin: 0 5px;
        &:hover{
            color: #FFFFFF;
            text-decoration: underline;
        }
    }
    img{
        vertical-align: middle;
        margin-top: -4px;
        margin-right: 5px;
    }
}

@media screen and (max-width:1200px){
    .footTop{
        padding: .3rem 0;
    }
    .ftLogo{
        img{
            max-height: 46px;
        }
    }
    .ftTel{
        margin: .2rem 0 .1rem;
    }
}
@media screen and (max-width:767px){

    .footTop{
        padding-top: .6rem;
        padding-bottom: 0;
    }
    .ftLeft{
        float: none;
        width: 100%;
        max-width: 100%;
        font-size: 14px;
    }
    .ftLogo{
        text-align: center;
    }
    .ftRight{
        float: none;
        max-width: 100%;
        margin: .3rem auto 0;
    }
}
</style>